module.exports = __webpack_public_path__ + "img/valid.1cd71805.gif";